import React from "react";

export default function NoDataMessage() {
  return (
    <div className="text-center w-full bg-slate-200 h-6 flex items-center justify-center font-bold">
      No data available
    </div>
  );
}
